import MConfetti from './MConfetti.vue';

export default MConfetti;
export { MConfetti };
